<template>
    <div>
        <news-and-events-welcome-bg/>
        <news-and-events-links/>
        <upcomingevents/>
    </div>
</template>

<script>
    import NewsAndEventsWelcomeBg from "../components/newsevents/NewsAndEventsWelcomeBg";
    import NewsAndEventsLinks from "../components/newsevents/newsAndEventsLinks";
    import Upcomingevents from "../components/home/upcomingEvents";
    export default {
        name: "NewsAndEvents",
        components: {Upcomingevents, NewsAndEventsLinks, NewsAndEventsWelcomeBg}
    }
</script>

<style scoped>

</style>